// extracted by mini-css-extract-plugin
export default {"add-participant-button":"ManualParticipantsManager_add-participant-button__T5LmH"};